<div class="test-data-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      Test Data
      <span class="test-case-id" *ngIf="data.testCaseId">- {{ data.testCaseId }}</span>
    </h2>
    <button class="close-button" (click)="onClose()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <pre class="test-data-content">{{ formattedData }}</pre>
  </div>
</div>

